import { Button } from "../button";
import { Icon } from "../icons";
import { useCopy } from "./use-copy";

/** Props Interface */
interface CopyButtonProps {
	/** What lands in the clipboard; the button is disabled while there is nothing to copy. */
	value: string | null | undefined;
	/** The accessible name, since the button shows an icon alone; wrap it in a `Tooltip` to show it. */
	label: string;
	className?: string;
}

/**
 * An icon-only copy control, the shape of the other icon buttons it stands beside — where `Copy`
 * is the inline control that shows the value it copies.
 */
export function CopyButton({ value, label, className }: CopyButtonProps) {
	/** Hooks */
	const { isCopied, copy } = useCopy(value);

	/** Render */
	return (
		<Button
			icon={<Icon name={isCopied ? "Check" : "Copy"} />}
			onClick={copy}
			isDisabled={!value}
			aria-label={label}
			className={className}
		/>
	);
}
